import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Select } from 'antd';
import appconstants from '../../../themes/appconstant';

const { Option } = Select;

const WhoCharts = ({ text, chartOptions, month, handleMonthChange }) => {
  const monthOptions = Array.from({ length: 12 }, (_, i) => ({
    value: i,
    label: new Date(0, i).toLocaleString('default', { month: 'long' }),
  }));

  return (
    <div className='border-royalPurple bg-white border rounded-[10px]'>
      <div className='text-base font-semibold flex items-center justify-between text-dark p-4 border-b months-selector'>
        <div>{text}</div>
        <div>
          <Select
            value={month}
            onChange={handleMonthChange}
            placeholder="Select a month"
     
          >
            {monthOptions.map((month) => (
              <Option key={month.value} value={month.value}>
                {month.label}
              </Option>
            ))}
          </Select>
        </div>
      </div>
      <ReactECharts option={chartOptions} />
    </div>
  );
};

export default WhoCharts;
